import React, { useState } from "react";
import { FiCode, FiPlus, FiX } from "react-icons/fi";

export default function SkillsSection({ values, setValues }) {
  const [newSkill, setNewSkill] = useState("");
  const skills = values.skills || [];

  const handleAdd = (e) => {
    e.preventDefault();
    const trimmedSkill = newSkill.trim();
    if (!trimmedSkill) return;
    
    // Check if skill already exists (case insensitive)
    const getSkillName = (s) => typeof s === 'object' ? (s.skill_name || s.name) : s;
    if (skills.some((s) => getSkillName(s)?.toLowerCase() === trimmedSkill.toLowerCase())) {
      setNewSkill("");
      return;
    }

    setValues({
      ...values,
      skills: [...skills, trimmedSkill],
    });
    setNewSkill("");
  };

  const handleRemove = (index) => {
    setValues({
      ...values,
      skills: skills.filter((_, i) => i !== index),
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd(e);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-purple-50 text-purple-600 rounded-lg">
          <FiCode className="w-5 h-5" />
        </div>
        <h2 className="text-lg font-bold text-gray-900">Skills</h2>
      </div>

      {/* Add skill input */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={newSkill}
          onChange={(e) => setNewSkill(e.target.value)}
          onKeyDown={handleKeyDown}
          className="input flex-1"
          placeholder="Add a skill (e.g. JavaScript, Project Management)"
        />
        <button
          type="button"
          onClick={handleAdd}
          disabled={!newSkill.trim()}
          className="btn btn-primary px-3 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FiPlus className="w-5 h-5" />
        </button>
      </div>

      {/* Skills list */}
      <div className="flex flex-wrap gap-2">
        {skills.length > 0 ? (
          skills.map((skill, index) => {
            const skillName = typeof skill === 'object' ? (skill.skill_name || skill.name) : skill;
            return (
            <span
              key={index}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 text-gray-800 rounded-full text-sm font-medium group"
            >
              {skillName}
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="p-0.5 text-gray-400 hover:text-red-600 transition-colors cursor-pointer"
              >
                <FiX className="w-3.5 h-3.5" />
              </button>
            </span>
          )})
        ) : (
          <p className="text-sm text-gray-500 italic">No skills added yet. Add skills to help recruiters find you.</p>
        )}
      </div>
    </div>
  );
}
